.kq{pointer-events:auto;}